import {
    normalizeBirthdate,
    normalizeStaffRole,
    STAFF_IMPORT_GRID_COLUMN_KEYS,
    StaffImportGridRow,
    StaffImportRow,
} from '../types/staffImport';

export const staffImportRowToGridRow = (
    row: StaffImportRow,
    index: number,
): StaffImportGridRow => ({
    id: `row-${index + 1}`,
    firstName: row.firstName,
    middleName: row.middleName,
    lastName: row.lastName,
    staffRole: normalizeStaffRole(row.role),
    email: row.email,
    employeeId: row.employeeId,
    gender: row.gender,
    streetAddress: row.street,
    city: row.city,
    state: row.state,
    zip: row.zipcode,
    country: row.country,
    birthday: row.birthdate,
    primaryPhone: row.phoneNumber,
    onlineLink: row.onlineLink,
});

export const mapStaffImportRowsToGridRows = (
    rows: StaffImportRow[],
): StaffImportGridRow[] =>
    rows.map((row, index) => staffImportRowToGridRow(row, index));

const createBlankStaffImportGridFields = (): Omit<StaffImportGridRow, 'id'> =>
    Object.fromEntries(
        STAFF_IMPORT_GRID_COLUMN_KEYS.map((key) => [key, '']),
    ) as Omit<StaffImportGridRow, 'id'>;

export const createEmptyStaffImportGridRow = (): StaffImportGridRow => ({
    id: `client-${crypto.randomUUID()}`,
    ...createBlankStaffImportGridFields(),
});

export const gridRowToProcessPayload = (row: StaffImportGridRow) => ({
    row_id: row.id,
    first_name: row.firstName,
    middle_name: row.middleName,
    last_name: row.lastName,
    email: row.email,
    phone_number: row.primaryPhone,
    role: row.staffRole,
    employee_id: row.employeeId,
    gender: row.gender,
    street: row.streetAddress,
    city: row.city,
    state: row.state,
    zipcode: row.zip,
    country: row.country,
    birthdate:
        row.birthday.trim().length > 0
            ? normalizeBirthdate(row.birthday)
            : null,
    online_link: row.onlineLink,
});
